/* CodeBlue homepage redesign (2026-11-02): lazy studio video + reviews slider. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktop = window.matchMedia('(min-width: 750px)');

  /* Studio video: poster first; set src and play only when ~300px from view.
     Desktop loads the square file, phones the tall file (shown 4:5). Reduced motion = poster only. */
  function initVideo(video) {
    if (video.dataset.cbhReady) return;
    video.dataset.cbhReady = '1';
    var poster = desktop.matches ? video.dataset.posterDesktop : video.dataset.posterMobile;
    if (poster) video.setAttribute('poster', poster);
    if (reduceMotion.matches) return;

    var load = function () {
      if (video.dataset.cbhLoaded) return;
      video.dataset.cbhLoaded = '1';
      video.src = desktop.matches ? video.dataset.srcDesktop : video.dataset.srcMobile;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };

    if (!('IntersectionObserver' in window)) { load(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { load(); io.disconnect(); }
      });
    }, { rootMargin: '300px 0px' });
    io.observe(video);
  }

  /* Reviews: scroll-snap track (swipe on phones), dots, gentle auto-advance on desktop. */
  function initReviews(root) {
    if (root.dataset.cbhReady) return;
    root.dataset.cbhReady = '1';
    var track = root.querySelector('[data-cbh-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-cbh-slide]'));
    if (!track || slides.length < 2) return;
    var current = 0;
    var timer = null;
    var paused = false;

    function setCurrent(i) {
      current = i;
      root.querySelectorAll('[data-cbh-dot]').forEach(function (dot) {
        dot.setAttribute('aria-current', Number(dot.dataset.cbhDot) === i ? 'true' : 'false');
      });
      slides.forEach(function (s, idx) {
        s.setAttribute('aria-hidden', idx === i ? 'false' : 'true');
        s.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = idx === i ? 0 : -1; });
      });
    }

    // While a dot/auto-advance scroll is animating, ignore scroll positions until it settles.
    var programmatic = false;
    var settleTimer;
    function goTo(i) {
      programmatic = true;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () { programmatic = false; }, 1200);
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      setCurrent(i);
    }

    root.addEventListener('click', function (e) {
      var dot = e.target.closest('[data-cbh-dot]');
      if (!dot) return;
      goTo(Number(dot.dataset.cbhDot));
      restart();
    });

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        if (programmatic) return;
        var i = Math.round(track.scrollLeft / (slides[1].offsetLeft - slides[0].offsetLeft));
        if (i !== current && slides[i]) setCurrent(i);
      }, 120);
    }, { passive: true });
    track.addEventListener('scrollend', function () { programmatic = false; });
    // A swipe or trackpad scroll ends any programmatic scroll.
    ['touchstart', 'wheel'].forEach(function (type) {
      track.addEventListener(type, function () { programmatic = false; }, { passive: true });
    });

    function tick() {
      if (paused || document.hidden) return;
      goTo((current + 1) % slides.length);
    }
    function restart() {
      clearInterval(timer);
      timer = null;
      if (!reduceMotion.matches && desktop.matches) timer = setInterval(tick, 8000);
    }
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    desktop.addEventListener && desktop.addEventListener('change', restart);

    setCurrent(0);
    restart();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-cbh-video]').forEach(initVideo);
    (scope || document).querySelectorAll('[data-cbh-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
